import { Component, OnInit } from '@angular/core'
import { FormFieldFactoryComponentAbstract } from '../../core/component/form-field-factory/form-field-factory.component-abstract'

@Component({
    selector: 'mga-form-factory-field-checkbox',
    templateUrl: './form-factory-field-checkbox.component.html',
    styleUrls: ['./form-factory-field-checkbox.component.scss'],
})
export class FormFactoryFieldCheckboxComponent extends FormFieldFactoryComponentAbstract {}
